module.exports = __webpack_public_path__ + "static/media/fil-l.5b3ce6c5.png";